export const HOST = process.env.REACT_APP_API_URL;
const URI = '/coin-conversion/merchant';

export const LOGIN = `${URI}/login`;
export const VERIFY_EMAIL_CODE = `${URI}/verify-email-code`;
export const LOGIN_BY_TOKEN = `${URI}/login-by-token`;
export const RESET_PASSWORD = `${URI}/reset-password`;
export const CHANGE_PASSWORD = `${URI}/password`;
export const LOGOUT = `${URI}/logout`;
export const UPDATE_SETTINGS = `${URI}/update-settings`;
export const CREATE_TEMP_TRANSACTION = `${URI}/create-temp-transaction`;
export const GET_TRANSACTION = `${URI}/coin-deposit-transaction`;
export const CREATE_REQUEST_HELP = `${URI}/request-help`;
